import { BankerValidationErrorsBadge } from "./BankerValidationErrorsBadge";
import { useStickyBankerApplicationDetailsForm } from "./useStickyBankerApplicationDetailsForm";
import { ValidationErrorDisplayMode } from "../ValidationErrorsCounts/ValidationErrorsCounts";
import "./StickyBankerApplicationDetailsForm.scss";

export interface StickyBankerApplicationDetailsFormProps {
  financialApplicationId: string;
}

export const StickyBankerApplicationDetailsForm: React.FC<StickyBankerApplicationDetailsFormProps> = ({
  financialApplicationId,
}) => {
  const { currentSection, navigationItems, setSectionRef, scrollToSection } =
    useStickyBankerApplicationDetailsForm(financialApplicationId);

  return (
    <div className="sticky-banker-application-details-form">
      {/* Left Navigation Bar */}
      <div className="left-navigation">
        <nav className="navigation-nav">
          <ul className="navigation-list">
            {navigationItems.map((item) => (
              <li key={item.id} className="navigation-item">
                <button
                  className={`navigation-link ${currentSection === item.id ? "active" : ""} ${item.disabled ? "disabled" : ""}`}
                  onClick={() => !item.disabled && scrollToSection(item.id)}
                  disabled={item.disabled}
                >
                  <span className="navigation-label">{item.label}</span>
                  {item.section && (
                    <BankerValidationErrorsBadge
                      financialApplicationId={financialApplicationId}
                      section={item.section}
                      popoverClassName="sticky-banker-application-details-form__popover"
                      displayMode={ValidationErrorDisplayMode.Remaining}
                    />
                  )}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Right Content Area */}
      <div className="right-content">
        {/* Render all form sections dynamically */}
        {navigationItems
          .filter((item) => !item.disabled)
          .map((item) => (
            // <PrimaryCard headerContent={
            //   <>
            //     {item.label}{" "}
            //     <BankerValidationErrorsBadge
            //       financialApplicationId={financialApplicationId}
            //       section={item.section}
            //       popoverClassName="sticky-banker-application-details-form__popover"
            //       displayMode={ValidationErrorDisplayMode.Remaining}
            //     />
            //   </>
            // } key={item.id}  ref={(el) => setSectionRef(item.id, el)} className="form-section">
            //   {item.component}
            // </PrimaryCard>
            <div key={item.id} ref={(el) => setSectionRef(item.id, el)} className="form-section">
              <div className="form-section-header-container">
                <h2 className="form-section-header">
                  {item.label}{" "}
                  <BankerValidationErrorsBadge
                    financialApplicationId={financialApplicationId}
                    section={item.section}
                    popoverClassName="sticky-banker-application-details-form__popover"
                    displayMode={ValidationErrorDisplayMode.Remaining}
                  />
                </h2>
              </div>
              {item.component}
            </div>
          ))}
      </div>
    </div>
  );
};
